import { render, staticRenderFns } from "./FilterWrapper.vue?vue&type=template&id=120dd880&"
import script from "./FilterWrapper.vue?vue&type=script&lang=js&"
export * from "./FilterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports